<div [formGroup]="form">
  <div class="row mt-2">
    <div class="col-4">
      <ca-form-field>
        <ca-label>
          {{ 'COMUN.DATOS_CONTACTO.EMAIL' | translate }}
        </ca-label>
        <input 
          caInput 
          placeholder="{{ 'COMUN.DATOS_CONTACTO.EMAIL' | translate }}"
          type="text" 
          formControlName="envio-email-tomador" />
      </ca-form-field>
    </div>
    <div class="col-4">
      <ca-form-field>
        <ca-label>
          {{ 'COMUN.DATOS_CONTACTO.EMAIL_MEDIADOR' | translate }}
        </ca-label>
        <input 
          caInput 
          placeholder="{{ 'COMUN.DATOS_CONTACTO.EMAIL_MEDIADOR' | translate }}"
          type="text" 
          formControlName="envio-email-mediador" />
      </ca-form-field>
    </div>
  </div>
</div>